module.exports = __webpack_public_path__ + "static/media/box.dc6073e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/endlessRunner/box.png
// module id = 998
// module chunks = 0